import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import { NavLink } from "reactstrap";
import Grid from "@mui/material/Grid";
import * as React from "react";
import TimeOutDialog from "components/common/TimeoutDialog";
import headerIcon from "../../../images/headerIcon.png";
import HomeIcon from "../../../images/home_mobile.svg";
import MoreIcon from "images/et-more.svg";
import AccessQrCode from "components/accessQrCode";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { HomeLayoutViewContext } from "components/HomeLayout";
import makeStyles from "@mui/styles/makeStyles";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import NavigationMobile from "./NavigationMobile";
import SystemMessageDialog from "components/common/SystemMessageDialog";
import _ from "lodash";
import NotSignOut from "components/accessQrCode/NotSignOut";

const useStyles = makeStyles((theme) => ({
	logoutBtn: {
		backgroundColor: "#f58220",
	},
	root: {
		position: "fixed",
		bottom: 80,
		right: theme.spacing(2),
		backgroundColor: "#f58220",
		color: "#fff",
		width: 30,
		height: 30,
		borderRadius: "50%",
		textAlign: "center",
	},
	color: "#f58220",
}));
function HomeLayoutMobile(props) {
	const {
		classes,
		user,
		timeoutOpen,
		emails,
		addresses,
		usefulLinks,
		sitemaps,
		logoLink,
		contactEmail,
		location,
		openQrCode,
		navRef,
		isFixed,
		setOpenQrCode,
		getUserEmail,
		promptLogout,
		onSessionExtend,
		closeSessionExtend,
		closeTimeout,
		doLogout,
		getExpTime,
		lastLoginTime,
		clickMenu,
		onlyOnPCDialog,
		setOnlyOnPCDialog,
	} = React.useContext(HomeLayoutViewContext);
	const classes2 = useStyles();
	const HOMEPAGE = user?.homePage ?? "/homepage";

	const [open, setOpen] = React.useState(false);
	const [openTop, setOpenTop] = React.useState(false);

	const mainRef = React.useRef(null);
	const toggleDrawer = (_event) => {
		setOpen(!open);
	};

	const isActive = (patchName) => {
		return !!(!open && location.pathname === patchName);
	};

	const goTop = () => {
		mainRef.current.scrollTop = 0;
	};

	const handleScrollThrottled = React.useCallback(
		_.throttle(() => {
			if (mainRef.current?.scrollTop > 100) {
				if (!openTop) {
					setOpenTop(true);
				}
			} else {
				setOpenTop(false);
			}
		}, 200),
		[openTop, setOpenTop, mainRef]
	);

	React.useEffect(() => {
		mainRef.current.addEventListener("scroll", handleScrollThrottled, true);
		return () => {
			mainRef.current?.removeEventListener("scroll", handleScrollThrottled, false);
		};
	}, [mainRef.current]);

	const getMenus = React.useCallback(() => {
		let res = [];
		const resMap = {
			CHANGE_PASSWORD: true,
			CONTACT_US: true,
		};
		let topMenus = user?.menus?.topMenus || [];
		let middleMenus = user?.menus?.middleMenus || [];

		middleMenus.forEach((element) => {
			let code = element.code.slice(3);
			if (!resMap[code]) {
				resMap[code] = true;
				res.push(element);
			}
		});
		topMenus.forEach((element) => {
			let c = element.code.slice(3);
			if (!resMap[c]) {
				resMap[c] = true;
				res.push(element);
			}
		});
		res.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
		res.forEach((element) => {
			let code = element.code.slice(3);
			if (
				code === "PROGRESS_REPORT" ||
				code === "PROGRESS_REPORT_ADM" ||
				code === "OUTPUT_REQUEST" ||
				code === "OUTPUT_REQUEST_MANAGEMENT" ||
				code === "ONLINE_INFO" ||
				code === "ONLINE_INFO_MANAGEMENT"
			) {
				element.path = "#";
			}
		});
		return res;
	}, [user?.menus]);

	const getResearcherFooterMenu = React.useMemo(() => {
		const isResearcher = user?.roles?.includes("RESEARCHER");
		if (!isResearcher) {
			return getMenus().slice(0, 2);
		}
		const topMenus = user?.menus?.topMenus || [];
		const footerMenuCodes = [
			{ code: "ACCESS_QR_CODE", title: "Access Code" },
			{ code: "MANAGE_BOOKINGS", title: "Bookings" },
		];
		if (!topMenus.length) return [];
		return footerMenuCodes.map((menuItem) => {
			const findObject = topMenus.find((item) => {
				const c = item.code.slice(3);
				return c === menuItem.code;
			});
			return {
				...findObject,
				title: menuItem.title,
			};
		});
	}, [user?.menus]);

	return (
		<div
			style={{
				height: "100%",
				overflow: "hidden",
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				width: "100%",
				fontFamily: "Quicksand-SemiBold",
			}}
		>
			<CssBaseline />
			<Grid container direction="column" style={{ height: "100%" }}>
				<Grid container direction="column" style={{ overflow: "hidden" }} flexWrap={"nowrap"}>
					<Grid container ref={navRef} className={isFixed ? classes.fixedTop : ""}>
						<Grid item container>
							<Grid
								container
								justifyContent="space-between"
								style={{ padding: "5px", backgroundColor: "#fff" }}
								alignItems="center"
							>
								<Grid container justifyContent={"center"}>
									<a href={logoLink} target={"_blank"}>
										<img
											src={headerIcon}
											style={{
												maxWidth: "100%",
											}}
										/>
									</a>
								</Grid>
								<Grid container style={{ paddingTop: 8 }}>
									<Grid container alignItems="center" justifyContent={"space-between"}>
										<Grid item>
											<Grid container direction="column" style={{ fontSize: "13px" }}>
												<Grid item container alignItems="center">
													<Grid item style={{ color: "#f58220", fontSize: 18 }}>
														{getUserEmail()}
													</Grid>
												</Grid>
												<Grid item>
													{lastLoginTime(sessionStorage.getItem("lastLoginTime"))}
												</Grid>
											</Grid>
										</Grid>
										<Grid item>
											<IconButton
												onClick={() => {
													doLogout();
												}}
												className={` ${classes2.logoutBtn}`}
												style={{ backgroundColor: "#f58220", padding: 5 }}
												size="large"
											>
												{/* badgeContent={3} */}
												<ExitToAppIcon sx={{ color: "white" }} style={{ fontSize: 21 }} />
											</IconButton>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid container style={{ margin: "0px", width: "100%", flex: 1, position: "relative" }}>
					<Grid
						ref={mainRef}
						container
						style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, overflowY: "auto" }}
					>
						<Grid
							container
							style={{ margin: "0px", width: "100%", minHeight: "calc(100% - 37px)", overflowX: "auto" }}
						>
							{props.children}
						</Grid>
						<Grid container style={{ backgroundColor: "#000", flex: 1 }} alignContent="end">
							<Grid
								item
								container
								justifyContent={"center"}
								style={{
									color: "#ffff",
									fontSize: "13px",
									padding: "8px 0",
									height: "37px",
									backgroundColor: "#333",
								}}
							>
								<Grid item>
									Copyright © {new Date().getFullYear()} Hospital Authority. All rights reserved.
								</Grid>
							</Grid>
						</Grid>

						{openTop && (
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								onClick={goTop}
								className={classes2.root}
							>
								<KeyboardArrowUpIcon />
							</Grid>
						)}
					</Grid>
					{open && (
						<NavigationMobile
							user={user}
							Link={Link}
							goTop={goTop}
							location={location}
							contactEmail={contactEmail}
							clickMenu={clickMenu}
							toggleDrawer={toggleDrawer}
							doLogout={doLogout}
							emails={emails}
							classes={classes}
							usefulLinks={usefulLinks}
							addresses={addresses}
							sitemaps={sitemaps}
							getMenus={getMenus}
						/>
					)}
				</Grid>
				<Grid
					container
					justifyContent={"space-around"}
					// alignItems={"center"}
					style={{
						lineHeight: 1.1,
						textAlign: "center",
						fontSize: 12,
						boxShadow: `0 -5px 10px 0 ${open ? "rgba(205, 205, 205, 0.5)" : "rgba(8, 8, 8, 0.5)"}`,
						zIndex: 10,
						padding: "10px 0",
					}}
				>
					<Grid item style={{ width: "20%" }}>
						<NavLink
							onClick={() => {
								setOpen(false);
								goTop();
							}}
							tag={Link}
							to={HOMEPAGE}
							active={isActive(HOMEPAGE)}
							style={{
								color: "#f58220",
								textAlign: "center",
								filter: `grayscale(${isActive(HOMEPAGE) ? 0 : 1})`,
							}}
						>
							<img style={{ height: 20, marginBottom: 5 }} src={HomeIcon} />
							<div>Homepage</div>
						</NavLink>
					</Grid>
					{getResearcherFooterMenu.map((item) => {
						return (
							<Grid item key={item.code} style={{ maxWidth: "22%", minWidth: "20%" }}>
								<NavLink
									onClick={() => {
										setOpen(false);
										clickMenu(item.code);
									}}
									tag={Link}
									to={item.path}
									active={isActive(item.path)}
									style={{
										color: "#f58220",
										textAlign: "center",
										filter: `grayscale(${isActive(item.path) ? 0 : 1})`,
									}}
								>
									<img style={{ height: 20, marginBottom: 5 }} src={item.icon} />
									<div>{item.title}</div>
								</NavLink>
							</Grid>
						);
					})}
					<Grid
						item
						style={{
							flex: 1,
							maxWidth: "20%",
							color: "#f58220",
							textAlign: "center",
							filter: `grayscale(${open ? 0 : 1})`,
						}}
						onClick={toggleDrawer}
					>
						<img style={{ height: 20, marginBottom: 5 }} src={MoreIcon} />
						<div>More</div>
					</Grid>
				</Grid>
			</Grid>
			<SystemMessageDialog
				open={onlyOnPCDialog}
				onClose={() => {
					setOnlyOnPCDialog(false);
				}}
			>
				<div>Function only available on PC.</div>
			</SystemMessageDialog>
			<TimeOutDialog open={timeoutOpen} onClose={closeTimeout} />
			{openQrCode && (
				<AccessQrCode
					onClose={() => {
						setOpenQrCode(false);
					}}
				/>
			)}
			{/* <NotSignOut /> */}
		</div>
	);
}

export default HomeLayoutMobile;
